import * as React from 'react';
import { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { ReadMoreLessOptions } from '../models/configuration/components/ReadMoreLessOptions';
import ReadMoreLess from './ReadMoreLess';
import { DataStore } from '../stores';

const CommentaryContent = styled<any, any>('div')`
    ${propStyles};
`;

CommentaryContent.defaultProps = {
    fontSize: 'sm',
    fontFamily: 'body',
    fontWeight: 'normal',
    lineHeight: '1.4',
    color: 'body',
    listStyle: 'none',
    marginY: 'md',
};

interface CommentariesProps {
    theme?: { [property: string]: string | number };
    dataStore?: DataStore;
    commentaries: Array<string>;
    showReadMoreLess?: boolean;
    readMoreLessOptions?: ReadMoreLessOptions;
}

export const Commentaries: React.SFC<CommentariesProps> = ({
    theme,
    commentaries = [],
    showReadMoreLess = false,
    readMoreLessOptions,
    dataStore,
    ...props
}) => {
    const commentaryContent = commentaries.map((commentary, index) => (
        <CommentaryContent
            key={index}
            dangerouslySetInnerHTML={{ __html: commentary }}
            {...theme.CommentaryContent}
            {...props}
        />
    ));
    return commentaries.length > 0 ? (
        <Fragment>
            {showReadMoreLess && !dataStore.isMobile ? (
                <ReadMoreLess readMoreLessOptions={readMoreLessOptions}>
                    {commentaryContent}
                </ReadMoreLess>
            ) : (
                <Fragment>{commentaryContent}</Fragment>
            )}
        </Fragment>
    ) : null;
};

export default inject('dataStore')(observer(withTheme(Commentaries)));



// WEBPACK FOOTER //
// ./src/Components/Commentaries.tsx